





































































































































import {Component, Prop, Vue} from 'vue-property-decorator';

import {IProjectMetadata} from '@/interfaces/report';
import {dateDisplayBasic, dateTimeDisplay} from '@/lib/util/dateFunctions';

import ScenarioContainer from '@/views/components/projects/ScenarioContainer.vue';
import ProjectBreadcrumb from '@/views/components/projects/ProjectBreadcrumb.vue';
import {BaseScenarioType, IBaseScenario} from '@/lib/types/IBaseScenario';
import {projectStore} from '@/store/store';
import SelectDesignScenarioType from '@/modules/design/views/components/SelectDesignScenarioType.vue';
import ErrorDisplay from '@/views/components/projects/ErrorDisplay.vue';
import {IDesignBaseScenario} from "@/modules/design/interfaces/shared";


@Component({
  components: {
    ErrorDisplay,
    SelectDesignScenarioType,
    ProjectBreadcrumb,
    ScenarioContainer,
  },
})
export default class ScenarioSelection extends Vue {
  @Prop() readonly pxProjectId!: number;

  dateDisplay = dateDisplayBasic;

  dateTimeDisplay = dateTimeDisplay;

  currentProject: IProjectMetadata | null = null;

  get projectName() {
    return this.currentProject ? this.currentProject.name : '[No Project Loaded]';
  }

  get httpErrors() {
    return projectStore.httpErrors;
  }

  scenarioTypes = BaseScenarioType;

  loadProjectScenarios() {
    projectStore.loadProjectScenarios(this.pxProjectId).then((result) => this.currentProject = result);
  }

  get designScenarios(): IDesignBaseScenario[] {
    const scenarios = [];
    if (this.currentProject) {
      if (this.currentProject.asphaltScenarios) {
        scenarios.push(...this.currentProject.asphaltScenarios);
      }

      if (this.currentProject.concreteScenarios) {
        scenarios.push(...this.currentProject.concreteScenarios);
      }

      if (this.currentProject.porousScenarios) {
        scenarios.push(...this.currentProject.porousScenarios);
      }

      if (this.currentProject.acOverlayScenarios) {
        scenarios.push(...this.currentProject.acOverlayScenarios);
      }
    }

    // console.log(this.currentProject);
    // console.log(scenarios);

    return scenarios;
  }


  get lccaScenarios(): IBaseScenario[] {
    const scenarios = [];
    if (this.currentProject && this.currentProject.lccaScenarios) {
      scenarios.push(...this.currentProject.lccaScenarios);
    }
    return scenarios;
  }

  get agencyScenarios() {
    const scenarios = [];
    if (this.currentProject && this.currentProject.agencyScenarios) {
      scenarios.push(...this.currentProject.agencyScenarios);
    }
    return scenarios;
  }

  get perroadScenarios() {
    const scenarios = [];
    if (this.currentProject && this.currentProject.perroadScenarios) {
      scenarios.push(...this.currentProject.perroadScenarios);
    }
    return scenarios;
  }

  get structureScenarios() {
    const scenarios = [];
    if (this.currentProject && this.currentProject.structureScenarios) {
      scenarios.push(...this.currentProject.structureScenarios);
    }
    return scenarios;
  }

  get tabToShow() {
    return projectStore.selectedScenarioTab;
  }

  setTab(scenarioType: BaseScenarioType) {
    console.log('SetTab', scenarioType);
    projectStore.setScenarioTab(scenarioType);
  }


  mounted() {
    this.loadProjectScenarios();
  }
}
